import { render, staticRenderFns } from "./CompanyClientBlackList.vue?vue&type=template&id=ca32d808&scoped=true&"
import script from "./CompanyClientBlackList.vue?vue&type=script&lang=js&"
export * from "./CompanyClientBlackList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyClientBlackList.vue?vue&type=style&index=0&id=ca32d808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca32d808",
  null
  
)

export default component.exports